// Rewrites Unsplash-hosted image URLs to request an appropriately-sized,
// modern-format image instead of whatever was seeded. Unsplash's delivery
// API (images.unsplash.com) supports these as query params. Every blog
// featured_image seeded from Unsplash carries only `?w=1200` (full hero
// size) regardless of where it's actually rendered — the blog listing grid
// displays it as a ~400px-wide thumbnail, so up to ~9x more pixel data than
// needed was downloading there (Siteguru Pagespeed flagged this 2026-08-07).
// Other sources (our own R2 cdn.happyages.com, inline SVG data URIs) aren't
// Unsplash-hosted and are returned unchanged.
export function optimizedImageUrl(url, width) {
  if (!url || !url.includes("images.unsplash.com")) return url;
  try {
    const u = new URL(url);
    u.searchParams.set("w", String(width));
    u.searchParams.set("auto", "format"); // serves WebP/AVIF where supported
    u.searchParams.set("q", "75");
    return u.toString();
  } catch {
    return url;
  }
}
